import reportConfigData from '../utils/reportConfigData'
import asyncDataHelper from '../../../utils/asyncDataHelper.js'
import {baseReportDownloadMixin} from "./base-report-download-mixin"

export default {
  mixins: [baseReportDownloadMixin],
  data () {
    return {
      fields: {
        _apo: {}
      }
    }
  },
  computed: {
    showApo () {
      if (this.currentConfig.hasOwnProperty('showApo')) {
        return this.currentConfig.showApo
      }
      return false
    },
    /**
     * @override
     */
    reportConfigData () {
      return reportConfigData
    }
  },
  methods: {
    /**
     * @override
     */
    transformFieldsBeforeSend () {
      this.transformed = Object.assign({}, this.fields)
      if (this.showApo) {
        this.transformed.mo = []
        for (let key in this.fields._apo) {
          if (Array.isArray(this.fields._apo[key])) {
            this.fields._apo[key].forEach(v => {
              this.transformed.mo.push(v)
            })
          }
        }
      }
      delete this.transformed._apo
    }
  },
  asyncData ({store, route, fromRoute, methods, ctx}) {
    return asyncDataHelper.execAsyncDataInGlobalComponent('r-analytic-report-apo-selector', {
      store,
      route,
      fromRoute,
      methods,
      ctx
    })
  }
}
